module.exports = __webpack_public_path__ + "img/404.6a8c12d7.svg";